import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PadContainer, HorizontalFlex } from 'smartsuite-ui';
import MeasureFilterInput from './MeasureFilterInput';
import {
    replaceInArray,
    removeFromArray,
} from '../../viewDashboards/widgets/utils/dataFormatUtils';

export default function MeasureFilters({
    legendFormatter,
    measures,
    saveWhereClauses,
    showMeasureFilters,
    whereClauses,
}) {
    const measureOptions = useMemo(
        () =>
            measures.map((measure) => ({
                textField: legendFormatter(measure),
                valueField: measure,
            })),
        [measures, legendFormatter]
    );

    function deleteWhereClause(index) {
        return () =>
            saveWhereClauses(
                removeFromArray(whereClauses, index).filter(
                    (whereClause) => whereClause.propertyName
                )
            );
    }

    function handleChange(index, keyName) {
        return (event) => {
            const value = keyName === 'values' ? [event.target.value] : event;

            const updatedWhereClause = {
                ...whereClauses[index],
                [keyName]: value,
            };

            const updatedWhereClauses = replaceInArray(
                updatedWhereClause,
                whereClauses,
                index
            );

            saveWhereClauses(
                updatedWhereClauses.filter(
                    (whereClause) => whereClause.propertyName
                )
            );
        };
    }

    if (!showMeasureFilters || _.isEmpty(measures)) {
        return null;
    }

    return (
        <>
            <PadContainer
                cssClassModifiers={['pad-medium', 'no-pad-left-right']}
            >
                <HorizontalFlex
                    cssClassModifiers={['flex-wrap', 'align-flex-end']}
                >
                    {whereClauses.map((whereClause, index) => (
                        <MeasureFilterInput
                            // eslint-disable-next-line react/no-array-index-key
                            key={`${whereClause?.propertyName?.valueField}${index}`}
                            deleteWhereClause={deleteWhereClause}
                            handleChange={handleChange}
                            index={index}
                            measureOptions={measureOptions}
                            whereClause={whereClause}
                        />
                    ))}
                </HorizontalFlex>
            </PadContainer>
            <hr className="divider divider--criteria" />
        </>
    );
}

MeasureFilters.propTypes = {
    legendFormatter: PropTypes.func,
    measures: PropTypes.instanceOf(Array).isRequired,
    saveWhereClauses: PropTypes.func.isRequired,
    showMeasureFilters: PropTypes.bool.isRequired,
    whereClauses: PropTypes.instanceOf(Array).isRequired,
};

MeasureFilters.defaultProps = {
    legendFormatter: (measure) => measure,
};
